import React from "react";
import { ProjectList } from "../../../data/ProjectData";
import {
  Card,
  CardLeft,
  CardRight,
  Stack,
  BtnGroup,
} from "./ProjectCardElements";
function ProjectCard() {
  return (
    <>
      {ProjectList.map((list, index) => (
        <Card key={index}>
          <CardLeft>
            <div style={{display:"flex",justifyContent:"center", alignItems:"center",height:"100%"}}>
            <img src={list.img} alt={list.name} />
            </div>
          </CardLeft>
          <CardRight>
            <h4>{list.title}</h4>
            <p>{list.description}</p>
            <Stack>
              <div style={{display:"flex",height:"auto" ,justifyContent:"space-between"}}>
              <span className="stackTitle">Tech Stack -</span>
              <div>
              <span className="tags">{list.tech_stack}</span>
              </div>
              </div>
            </Stack>
            <BtnGroup>
              <a                                                    
                className="btn PrimaryBtn"
                href={list.demo_url}
                target="_blank"
                rel="noopener noreferrer"
              >
                see live ➜
              </a>
            </BtnGroup>
          </CardRight>
        </Card>
      ))}
    </>
  );
}

export default ProjectCard;
